import { Environment } from './config';
import * as gql from './gql';

export type PracticeCardItem =
  | gql.typesClient.Query_CurrentUser_CurrentUser_recent_user_created_activity
  | gql.typesClient.Query_CurrentUser_CurrentUser_recent_meditation_activity
  | gql.typesClient.Query_CurrentUser_CurrentUser_recent_class_activity;

export type RecentActivity =
  gql.typesClient.Query_CurrentUser_RecentActivities_CurrentUser_recent_activity_SeriesActivity;

export type CardItem =
  | gql.typesClient.Fragment_ArticleCard
  | gql.typesClient.Fragment_ClassCard
  | gql.typesClient.Fragment_CourseCard
  | gql.typesClient.Fragment_MeditationCard
  | PracticeCardItem;

export const isClassCardItem = (item: CardItem): item is gql.typesClient.Fragment_ClassCard =>
  item && 'localized_path' in item && /class\//.test(item.localized_path);

export const isCourseCardItem = (item: CardItem): item is gql.typesClient.Fragment_CourseCard =>
  item && 'localized_path' in item && /ecourse\//.test(item.localized_path);

export const isMeditationCardItem = (
  item: CardItem,
): item is gql.typesClient.Fragment_MeditationCard =>
  item && 'localized_path' in item && /meditation\//.test(item.localized_path);

export const isArticleCardItem = (item: CardItem): item is gql.typesClient.Fragment_ArticleCard =>
  item && 'localized_path' in item && /article\//.test(item.localized_path);

export const isEnvironment = (env: any): env is Environment => {
  if (typeof env !== 'string') {
    return false;
  }
  switch (env) {
    case 'development':
      return true;
    case 'experimental':
      return true;
    case 'staging':
      return true;
    case 'production':
      return true;
    case 'test':
      return true;
    default:
      return false;
  }
};
